import { FC, ReactElement } from 'react';
import styled from 'styled-components';
import ModalLayout from './ModalLayout';
import { ModalButtonLine } from './ModalButtonLine';

const StSpacer = styled.div`
    display: block;
    margin-left: 5px;
    margin-right: 5px;
`;

/**
 * ModalLayout with predefined footer
 */

interface Props {
    okButton?: ReactElement;
    cancelButton?: ReactElement;
    header?: ReactElement;
    content?: ReactElement;
    visible: boolean;
    onClose: () => void;
    width?: number;
    destroyOnClose?: boolean;
    closeOnEsc?: boolean;
    closable?: boolean;
    style?: object;
}
const BasicModalLayout: FC<Props> = props => {
    const {
        header,
        content,
        okButton,
        cancelButton,
        visible,
        onClose,
        width,
        destroyOnClose,
        closeOnEsc,
        closable,
        style
    } = props;

    const footer = (
        <ModalButtonLine>
            {cancelButton}
            <StSpacer />
            {okButton}
        </ModalButtonLine>
    );

    return (
        <ModalLayout
            header={header}
            content={content}
            footer={footer}
            visible={visible}
            onClose={onClose}
            width={width}
            destroyOnClose={destroyOnClose}
            closeOnEsc={closeOnEsc}
            closable={closable}
            style={style}
            className="basic-modal-layout"
        />
    );
};

export default BasicModalLayout;
